import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export type StripeSubStatus = "active" | "trialing" | "past_due" | "canceled" | "incomplete" | "incomplete_expired" | "unpaid";

export type SubscriptionSummary = {
  id: string;
  status: StripeSubStatus;
  cancel_at_period_end: boolean;
  current_period_end: number; // unix seconds
  current_period_start: number; // unix seconds
  priceId: string;
  productName?: string;
  interval?: "month" | "year";
};

export const subscriptions = async () => {
  const res = await axios.get(`${clientVitalsAPI}/stripe/subscriptions`);
  return res.data
};

export const fetchSubscription = async (customerId: string) => {
  if (!customerId) return null;
  const res = await axios.get(`${clientVitalsAPI}/stripe/subscriptions/${customerId}`);
  return res.data as SubscriptionSummary | null;
};

export const cancelSubscription = async (subscriptionId: string, cancelAtPeriodEnd = true) => {
  if (!subscriptionId) return null;
  const res = await axios.post(`${clientVitalsAPI}/stripe/subscriptions/cancel`, {
    subscriptionId,
    cancelAtPeriodEnd,
  });
  return res.data;
};

export const upgradeSubscription = async (subscriptionId: string, newPriceId: string) => {
  if (!subscriptionId || !newPriceId) return null;
  const res = await axios.post(`${clientVitalsAPI}/stripe/subscriptions/upgrade`, {
    subscriptionId,
    newPriceId,
  });
  return res.data;
};
